/**
 * Overrides for foreign key columns when track matching shows joined/summary
 * shapes that don't match models.json. Keyed by entity name, then field name.
 * Add entries here instead of modifying models.json for special views.
 */
export const TRACK_MATCHING_FOREIGN_KEY_OVERRIDES: Record<string, Record<string, string>> = {
  // Used when a row's effective entity is Artist (e.g. join/summary) so *_id columns resolve correctly.
  Artist: { album_id: 'Album', artist_id: 'Artist', genre_id: 'Genre' },
};
